/* eslint-disable import/no-named-as-default-member */

import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';

import {
  auth,
} from '@/store/modules/auth';
import {
  profile,
} from '@/store/modules/profile';
import {
  systemMessages,
} from '@/store/modules/system-messages';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export const store = new Vuex.Store({
  modules: {
    auth,
    profile,
    systemMessages,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});
